import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  captureStack1fzi4aczwc4hg as captureStack,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var HttpMethod_GET_instance;
var HttpMethod_POST_instance;
var HttpMethod_PUT_instance;
var HttpMethod_PATCH_instance;
var HttpMethod_DELETE_instance;
var HttpMethod_HEAD_instance;
var HttpMethod_entriesInitialized;
function HttpMethod_initEntries() {
  if (HttpMethod_entriesInitialized)
    return Unit_instance;
  HttpMethod_entriesInitialized = true;
  HttpMethod_GET_instance = HttpMethod().rcx('GET', 0);
  HttpMethod_POST_instance = HttpMethod().rcx('POST', 1);
  HttpMethod_PUT_instance = HttpMethod().rcx('PUT', 2);
  HttpMethod_PATCH_instance = HttpMethod().rcx('PATCH', 3);
  HttpMethod_DELETE_instance = HttpMethod().rcx('DELETE', 4);
  HttpMethod_HEAD_instance = HttpMethod().rcx('HEAD', 5);
}
var HttpMethodClass;
function HttpMethod() {
  if (HttpMethodClass === VOID) {
    class $ extends Enum() {
      static rcx(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'HttpMethod');
    HttpMethodClass = $;
  }
  return HttpMethodClass;
}
var ConnectionExceptionClass;
function ConnectionException() {
  if (ConnectionExceptionClass === VOID) {
    class $ extends Exception() {
      static ocx(message, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.vd(message, cause);
        captureStack($this, $this.ncx_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ConnectionException');
    ConnectionExceptionClass = $;
  }
  return ConnectionExceptionClass;
}
var RequestBodyTextClass;
function RequestBodyText() {
  if (RequestBodyTextClass === VOID) {
    class $ {
      constructor(content, type) {
        this.scx_1 = content;
        this.tcx_1 = type;
      }
      toString() {
        return 'RequestBodyText(content=' + this.scx_1 + ', type=' + this.tcx_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.scx_1);
        result = imul(result, 31) + getStringHashCode(this.tcx_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RequestBodyText()))
          return false;
        if (!(this.scx_1 === other.scx_1))
          return false;
        if (!(this.tcx_1 === other.tcx_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'RequestBodyText');
    RequestBodyTextClass = $;
  }
  return RequestBodyTextClass;
}
var RequestBodyFileClass;
function RequestBodyFile() {
  if (RequestBodyFileClass === VOID) {
    class $ {
      constructor(content) {
        this.ucx_1 = content;
      }
      toString() {
        return 'RequestBodyFile(content=' + toString(this.ucx_1) + ')';
      }
      hashCode() {
        return hashCode(this.ucx_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RequestBodyFile()))
          return false;
        if (!equals(this.ucx_1, other.ucx_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'RequestBodyFile');
    RequestBodyFileClass = $;
  }
  return RequestBodyFileClass;
}
var RequestBodyBlobClass;
function RequestBodyBlob() {
  if (RequestBodyBlobClass === VOID) {
    class $ {}
    initMetadataForClass($, 'RequestBodyBlob');
    RequestBodyBlobClass = $;
  }
  return RequestBodyBlobClass;
}
function HttpMethod_GET_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_GET_instance;
}
function HttpMethod_POST_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_POST_instance;
}
function HttpMethod_PUT_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_PUT_instance;
}
function HttpMethod_PATCH_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_PATCH_instance;
}
function HttpMethod_DELETE_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_DELETE_instance;
}
//region block: exports
export {
  ConnectionException as ConnectionException1wjs7wwnknnfm,
  RequestBodyBlob as RequestBodyBlob1w7e8wxebrdro,
  RequestBodyFile as RequestBodyFile26cfvm0aih79m,
  RequestBodyText as RequestBodyTextpvofjwd95b3y,
  HttpMethod_DELETE_getInstance as HttpMethod_DELETE_getInstance1ayy9xx1uf6c9,
  HttpMethod_GET_getInstance as HttpMethod_GET_getInstance2m1rvu4d8a2j3,
  HttpMethod_PATCH_getInstance as HttpMethod_PATCH_getInstance2444xhczsg6ri,
  HttpMethod_POST_getInstance as HttpMethod_POST_getInstance3c6ouf174z7cx,
  HttpMethod_PUT_getInstance as HttpMethod_PUT_getInstance1ik48aaxkshw8,
};
//endregion

//# sourceMappingURL=fetch.mjs.map
